<template>
  <nav>
    <router-view />
  </nav>
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
* {
  padding: 0;
  margin: 0 auto;
}
nav {
  margin: 0 auto;
}
</style>
